export const COMPANY_NAME = "N1 CARE CONSULTING, INC";
export const COMPANY_SHORT = "N1 Care Consulting";
export const COMPANY_INITIALS = "N1C";
export const COMPANY_ADDRESS_FULL = "419 W Glenoaks Blvd APT 106, Glendale, CA 91202-3604";
export const COMPANY_LOCATION = "Glendale, CA";
export const COMPANY_REGION = "Los Angeles County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=419%20W%20Glenoaks%20Blvd%20APT%20106%2C%20Glendale%2C%20CA%2091202-3604";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile", "value": "Public directory" },
  { "label": "Region", "value": "Los Angeles County" },
  { "label": "Location", "value": "Glendale, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "N1 CARE CONSULTING, INC" },
  { "label": "City / State", "value": "Glendale, CA" },
  { "label": "Address", "value": "419 W Glenoaks Blvd APT 106, Glendale, CA 91202-3604" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Public profile", "body": "This page presents only public-facing organization and location details." },
];
